module.exports = __webpack_public_path__ + "img/icon-data04.65aaa5f0.png";